module.exports = __webpack_public_path__ + "img/icon-ranking-3@3x.3e85db61.png";